<template>
  <div class="px-4 lg:px-0 xl:px-0 2xl:px-0">
      <div v-if="!hideFilters"
        class="search-container container mx-auto mt-6 lg:sticky lg:top-0 md:sticky md:top-0 sm:mt-0 sm:px-4 sm:pin-none rounded"
      >
        <div class="md:px-6 md:border-gray-200">
          <form class="package-search-form text-gray-700">
            <div class="lg:flex lg:justify-between flex-wrap">
              <div class="lg:flex-1 lg:flex md:flex md:flex-wrap md:mb-2">
                <div class="lg:flex-1 lg:pr-2 md:w-1/2 sm:mb-2">
                  <div class="relative lg:pr-2">
                    <select2
                      :options="localityOptions"
                      :placeholder="translate('search.select-any-locality')"
                      v-model="selectedLocality"
                      class="text-gray-700 w-full block appearance-none bg-white border border-gray-500 pl-10 px-4 py-2 pr-8 sm:mb-2"
                    ></select2>
                    <i
                      class="far fa-tasks absolute left-0 top-0 mt-3 ml-3"
                      data-fa-transform="grow-1 down-2"
                    ></i>
                  </div>
                </div>
                <div class="lg:flex-1 md:w-1/2 sm:mb-2">
                  <div class="relative">
                    <select2
                      :options="categoryOptions"
                      :placeholder="translate('search.select-category')"
                      v-model="selectedCategory"
                      class="text-gray-700 w-full block appearance-none bg-white border border-gray-500 pl-10 px-4 py-2 pr-8 sm:mb-2"
                    ></select2>
                    <i
                      class="far fa-tasks absolute left-0 top-0 mt-3 ml-3"
                      data-fa-transform="grow-1 down-2"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="container mx-auto mt-6 tablet-landscape-fix">
        <paginate name="filteredServices" :list="filteredServices" :per="10" tag="div">
          <div class="grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6 mb-8">
            <service
              v-for="service in paginated('filteredServices')"
              :service="service"
              :key="service.id"
            ></service>
          </div>
        </paginate>

        <paginate-links v-if="!hidePagination" for="filteredServices" :limit="9" :show-step-links="true"></paginate-links>
      </div>
    
  </div>
</template>

<script>
export default {
  name: "service-list",

  props: {
    services: Array,
    hideFilters: Boolean,
    hidePagination: Boolean,
    preSelectedLocality: String,
    preSelectedCategory: String
  },

  data() {
    return {
      servicesForLocalityFilter: this.services,
      servicesForCategoryFilter: this.services,
      selectedLocality: this.preSelectedLocality,
      selectedCategory: this.preSelectedCategory,
      paginate: ["filteredServices"]
    };
  },

  computed: {
    filteredServices: function() {
      let filtered = this.services;
      let selectedLocality = parseInt(this.selectedLocality);
      let selectedCategory = parseInt(this.selectedCategory);

      if (selectedLocality) {
        filtered = _.filter(filtered, function(service) {
          return service.state_or_country.id == selectedLocality;
        });
      }

      if (selectedCategory) {
        filtered = _.filter(filtered, function(service) {
          let serviceCategories = _.map(service.categories, function(category) {
            return category.id;
          });

          return _.includes(serviceCategories, selectedCategory);
        });
      }

      return filtered;
    },

    localityOptions: function() {
      let collection = this.servicesForLocalityFilter;

      let allLocalities = _.map(collection, function(service) {
        return service.state_or_country;
      });

      let uniqueLocalities = _.uniqBy(allLocalities, function(locality) {
        return locality.id;
      });
      return uniqueLocalities;
    },

    categoryOptions: function() {
      let collection = this.servicesForCategoryFilter;

      let allCategories = _.flatMap(collection, function(service) {
        return service.categories;
      });

      let uniqueCategories = _.uniqBy(allCategories, function(category) {
        return category.id;
      });

      return uniqueCategories;
    }
  },

  beforeUpdate() {
    $(".lg\\:flex-grid-1\\/3 > div:empty").remove();
  },

  updated() {
    this.$nextTick(function() {
      this.fixGrid();
    });
  },

  watch: {
    selectedLocality: {
      handler: function(newVal, _oldVal) {
        if (newVal) {
          // Locality Selected
          this.servicesForCategoryFilter = this.filteredServices;
        } else {
          // Locality deselected
          this.servicesForCategoryFilter = this.services;
        }
      },
      immediate: true
    },

    selectedCategory: {
      handler: function(newVal, _oldVal) {
        if (newVal) {
          this.servicesForLocalityFilter = this.filteredServices;
        } else {
          this.servicesForLocalityFilter = this.services;
        }
      },
      immediate: true
    }
  },

  methods: {
    fixGrid: function() {
      let $grid = $(".lg\\:flex-grid-1\\/3");

      if (($grid.children().length + 1) % 3 == 0) {
        $grid.append("<div></div>");
      }
    }
  }
};
</script>
